import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Datatable.styles.css";
import messageIcon from '../../assets/images/messageicon.png';
import { Dialog } from 'primereact/dialog';
import CARAccordion from '../Accordion/Accordion';
import ClientAction from '../Clientaction/Clientaction';
import Activity from '../Activity/Activity';
import Docupload from '../Docupload/Docupload';
import ProgressBar from '../Progressbar/Progressbar';
import { Certificate } from '../../utils/types';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import SummaryReport from '../../pages/SummaryReport';
import { getCar } from '../../services/auth.api';
import { getCarmessages, postCarmessages } from '../../services/auth.api';
import { decodeJWT } from '../../utils/commonFns';
import { CarCommonService, MessageService, UploadService } from '../../services';
import Toaster from '../Toaster/Toster';
import Loader from '../Loader/loader.components';
import CarStatusTracker from '../CarStatusTracker';
import downloadIcon from "../../assets/images/downloadIcon.svg";
import { sortDataByDate, dateConversion } from '../../utils/formatDate';
import FloatButton from '../FloatButton';

const gradeColors: { [key: string]: string } = {
  "Major": "#C43131",
  "Minor": "#F49632",
  Observation: "#919191",
};
interface Column {
  key: keyof Certificate;
  label: string;
}

interface DataTableProps {
  initialData: Certificate[];
  columns: Column[];
  context: 'cars' | 'reports';
  rawReports?: any[] | null;
  fetchProject?: any;
}

const DataTable: React.FC<DataTableProps> = ({ initialData: initialData, columns, context, rawReports, fetchProject }) => {
  const navigate = useNavigate();
  const [data, setData] = useState<Certificate[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [visible, setVisible] = useState<boolean>(false);
  const [clientstatementvisible, setClientStatementVisible] = useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isSummaryReportVisible, setSummaryReportVisible] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedRowType, setSelectedRowType] = useState<string>();
  const [selectedRowData, setSelectedRowData] = useState<Certificate>();
  const [updateTimeline, setUpdateTimeline] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [activities, setActivities] = useState<any[]>([]);
  const [carData, setCarData] = useState<any>(null);
  const [message, setMessage] = useState<string>("");
  const [showToster, setShowToster] = useState<boolean>(false);
  const [tosterInfo, setTosterInfo] = useState<{ type: "success" | "error" | "warning", message: string }>({ type: "success", message: "" });
  const [filesInfo, setFilesInfo] = useState<any[]>([]);
  const [isFolderPath, setIsFolderPath] = useState<boolean>(false);
  const [isDocSuccess, setIsDocSuccess] = useState<boolean>(false);
  const [isDocFail, setIsDocFail] = useState<boolean>(false);
  const [selectedReport, setSelectedReport] = useState<any[] | null>(null);
  const [draftStatus, setDraftStatus] = useState("modified");

  const handleExport = async () => {
    const pdf = new jsPDF();
    const element = document.querySelector('.cardetailsmodel') as HTMLElement;
    if (element) {
      const messageElement = document.querySelector('.activityContent') as HTMLElement;
      messageElement?.classList.add("activityContent-export");
      const uploadElement = document.querySelector('.drop-file-preview') as HTMLElement;
      uploadElement?.classList.add("drop-file-preview-export");
      const canvas = await html2canvas(element, {
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: 1400,
      });
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 0);
      pdf.save('data_export.pdf');
      messageElement?.classList.remove("activityContent-export");
      uploadElement?.classList.remove("drop-file-preview-export");
    }
  };
  useEffect(() => {
    // Filtering logic
    setData(sortDataByDate(initialData, context === "cars" ? "dueDate" : "auditDate", sortDirection));
  }, [initialData]); // Ensure both are included

  const sortData = (key: keyof Certificate) => {
    const sortedData = sortDataByDate(data, context === "cars" ? "dueDate" : "auditDate", sortDirection === 'asc' ? 'desc' : 'asc');
    console.log(sortedData)
    setData(sortedData);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };

  const handleRowClick = (item: any) => {
    setSelectedId(item.id);
    setSelectedRowData(item);
    console.log(item)
    if (context === 'reports') {
      setSummaryReportVisible(true);
      setSelectedRowType('reports')
      const foundReport = rawReports?.find((report: any) => report.id === item.id);
      setSelectedReport(foundReport);
    } else if (context === 'cars') {
      setVisible(true);
      setSelectedRowType('cars')
      // fetchMessages();
      fetchCarData(item.id)
    }
  };

  useEffect(() => {
    if (visible) {
      //fetchCarData();
    }
  }, [visible]);

  const fetchCarData = async (id: string) => {
    setIsLoading(true);
    await CarCommonService.getCar(id)
      .then(response => {
        setCarData(response);
        fetchUploadedFile(response);
        fetchMessages(response?.correctiveActionRequest?.id);
        setIsFolderPath(response?.shareFileFolderId?.customerSubmissionFolderId ? true : false)
        setIsLoading(false);
      })
      .catch(error => {
        console.log("Error fetching car data:", error);
        setIsLoading(false);
      })
  };


  const fetchUploadedFile = async (carInfo: any) => {
    if (carInfo?.shareFileFolderId?.customerSubmissionFolderId) {
      await UploadService.getUploads(carInfo?.shareFileFolderId?.customerSubmissionFolderId)
        .then(response => {
          if (response) {
            setFilesInfo(response);
          } else setFilesInfo([]);
        })
        .catch(error => {
          console.log(error)
          setFilesInfo([]);
        })

    }
  };

  const onFileUpload = async (files: File[]) => {
    if (isFolderPath) {

      // all files should be in valid format i.e .pdf,.txt,.doc,.xls
      const validFileTypes = ["application/pdf", "text/plain", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      const validFiles = files.filter((file) => validFileTypes.includes(file.type));
      if (validFiles.length !== files.length) {
        setTosterInfo({ type: "error", message: `The file type you uploaded is not supported, please upload a .pfd, .xls, .txt or .docx.` });
        setShowToster(true);
        setIsDocFail(true);
        setTimeout(() => {
          setIsDocFail(false);
        }, 4000)
        return;
      } else if (files.every(file => file.size > 10 * 1024 * 1024 + 5)) {
        setTosterInfo({ type: "error", message:  `This file exceeds the max allowed file size. Please upload a file that does not exceed 10mb.` });
        setShowToster(true);
        setIsDocFail(true);
        setTimeout(() => {
            setIsDocFail(false);
        }, 4000)
        return;
      } else {
        // all files should be in valid format i.e .pdf,.txt,.doc,.xls
        setIsLoading(true);
        for (const file of files) {
          await UploadService.addUploads(file, carData?.shareFileFolderId?.customerSubmissionFolderId)
            .then(response => {
              setIsDocSuccess(true);
              fetchUploadedFile(carData);
              setTosterInfo({ type: "success", message: `CAR File uploaded successfully.` });
              setShowToster(true)
              setIsLoading(false);

              setTimeout(() => {
                setIsDocSuccess(false);
              }, 4000)

            })
            .catch(error => {
              setIsDocFail(true);
              setTosterInfo({ type: "error", message: `It seems there was an error on our end preventing your upload from completing, please try uploading the document again.` });
              setShowToster(true)
              setIsLoading(false);

              setTimeout(() => {
                setIsDocFail(false);
              }, 4000)
            })
        }
      }
    } else {
      setTosterInfo({ type: "error", message: `Something went wrong on our end, please try uploading your document again.` });
      setShowToster(true)
    }
  };

  const renderSortIcon = () => {
    return (
      <span>
        {sortDirection === 'asc' ? (
          <i className="bi bi-arrow-up" style={{ fontSize: '0.8em' }}></i>
        ) : (
          <i className="bi bi-arrow-down" style={{ fontSize: '0.8em' }}></i>
        )}
      </span>
    );
  };

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  const steps = ['Report pending', 'Under SCS Review', 'Completed'];

  const handleSaveCar = async () => {
    setDraftStatus("started");
    setIsLoading(true);
    const updatedCar = {
      scheme: selectedRowData?.scheme,
      issueDate: carData?.correctiveActionRequest.CreatedDate,
      grade: carData?.correctiveActionRequest.Grade__c,
      primaryStandardReference: carData?.correctiveActionRequest.Primary_Standard_Reference__c,
      status: "Evidence Review",
      section: carData?.correctiveActionRequest.Clause__c,
      siteIssuedTo: carData?.correctiveActionRequest.Customer_Site__c,
      observationDescriptionOfNonconformance: carData?.correctiveActionRequest.Observation_Description_of_Nonconforma__c,
      nonconformanceEvidence: carData?.correctiveActionRequest.Non_Conformance_Evidence__c,
      otherApplicableReferences: carData?.correctiveActionRequest.Other_Reference__c,
      reverted: carData?.correctiveActionRequest.Reverted_Draft__c,
    };
    await CarCommonService.updateCAR(carData?.correctiveActionRequest.id, updatedCar)
    .then(response => {
      setDraftStatus("success");
      setTosterInfo({ type: "success", message: `CAR submited for review successfully.` });
        setShowToster(true);
        setTimeout(() => {
        setDraftStatus("modified");
        setVisible(false);
        fetchProject();
        }, 2500);
    })
    .catch((error) => {
      setTosterInfo({ type: "error", message: `CAR Submission for review failed.` });
      setShowToster(true);
      setDraftStatus("modified");
      console.error("Submission failed:", error);
      setIsLoading(false);
    })
  }

  const headerContent = (
    <>
      <div className="d-flex">
        <p>{carData?.correctiveActionRequest?.Name || "--"} &nbsp;&nbsp;</p>
        <button type="button" className="btn btn-secondary bt-export details-export" onClick={handleExport}>
          Export <img src={downloadIcon} alt="download Icon" className="car-download-icon" />
        </button>
      </div>
      <CarStatusTracker status={carData?.correctiveActionRequest?.Status__c} />
      {/* <ProgressBar steps={steps} currentStep={currentStep} /> */}
      <button type="button" className="btn btn-secondary guidance-button" onClick={() => setClientStatementVisible(true)}>
        Client Guidance Statement &nbsp;<span className="bi bi-pencil-square"></span>
      </button>
    </>
  );

  const handleMessagePosted = () => {
    setUpdateTimeline((prev) => !prev);
  };


  const fetchMessages = async (id: string) => {
    await MessageService.getCarMessage(id)
      .then(response => {
        setActivities(response.messages || []);
      })
      .catch(error => {
        console.log('Error fetching car messages:', error);
      })
  };

  const handleSubmitMessage = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const token = localStorage.getItem('access_token');
    if (!token) {
      setTosterInfo({ type: "error", message: `Auth Token not found.` });
      setShowToster(true);
      return;
    }

    const decodedToken = decodeJWT(token);
    console.log(decodedToken)

    const senderContact = decodedToken.salesforceId;

    const messagePayload = {
      messageBody: message,
      senderContact: senderContact,
      car: carData?.correctiveActionRequest?.id,
      recipientUser: "",
      logoRequest: "",
      projectId: selectedRowData?.projectId,
    };

    await MessageService.addCarMessage(messagePayload)
      .then(response => {
        fetchMessages(carData?.correctiveActionRequest?.id);
        setIsLoading(false);
        setTosterInfo({ type: "success", message: `Message was sent successfully.` })
        setShowToster(true);
        setMessage("")
      })
      .catch(error => {
        setIsLoading(false);
        setTosterInfo({ type: "error", message: `Message was not sent, Please try after some time.` });
        setShowToster(true);
        setMessage("")
      });
  }

  return (
    <div className='main-container'>
      <div className="car-table-container">
        <table className="allfindingstable table fixed_header">
          <thead className="thead-light">
            <tr>
              {columns.map(col => (
                <th key={col.key} onClick={() => sortData(col.key)}>
                  {col.label}
                  {col.key === 'dueDate' && renderSortIcon()}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='car-table-body-container'>
            {data.map((item: Certificate, index) => (
              <tr
                key={index}
                onClick={() => handleRowClick(item)}
                className={context === 'cars' && item.status === 'Closed' ? 'customter-active' : 'customter'}
                style={{ cursor: 'pointer' }}
              >
                {context === 'cars' ? (
                  <>
                    <td>{item.parentCertificate || "--"}</td>
                    <td>{item.certificateId || "--"}</td>
                    <td>{item.siteName || "--"}</td>
                    <td>{item.findingId || "--"}</td>
                    <td>
                      <span className='' style={{ color: gradeColors[item.grade], fontWeight: 600 }}>
                        {item.grade || "--"}
                      </span>
                    </td>
                    <td style={{ fontWeight: 600 }}>{item.status || "--"}</td>
                    <td>{item.dueDate ? dateConversion(item.dueDate, "MMMM DD,YYYY") : "--"}</td>
                  </>
                ) : (
                  <>
                    <td>{item.accountName || "--"}</td>
                    <td>{item.projectName || "--"}</td>
                    <td>{item.certificateId || "--"}</td>
                    <td style={{ fontWeight: 800 }}>{item.status || "--"}</td>
                    <td>{item.auditDate ? dateConversion(item.auditDate, "MMMM DD,YYYY") : "--"}</td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog className='cardetailsmodel' header={headerContent} visible={visible} position={"right"} style={{ width: '50vw' }} onHide={() => { if (!visible) return; setVisible(false); setFilesInfo([]); }} draggable={false} resizable={false}>
        <>
          <br />
          {!isLoading ? "" : <Loader />}
          <CARAccordion carData={carData} projectCarData={selectedRowData} />
          <hr />
          <h2 className="new-message-title">Client Action</h2>
          <div className='row'>
            <div className='col-12 col-sm-12 col-6 col-lg-6'>
              <ClientAction activities={activities} isLoading={isLoading} message={message} setmessage={setMessage} handleSubmitMessage={handleSubmitMessage} sidebyside={false} />
              <br />
              {/* <Activity activities={activities} isLoading={isLoading} /> */}
            </div>
            <div className='col-12 col-sm-12 col-6 col-lg-6 mt-2'>
              <Docupload filesInfo={filesInfo} visible={visible} disabled={false} isFolderPath={isFolderPath} isDocSuccess={isDocSuccess} isDocFail={isDocFail} onFileUpload={onFileUpload} />
              <div className="text-right mt-2">
                {/* <button type="submit" className="submit-action">Submit</button> */}
              </div>
            </div>
          </div>
          {carData?.correctiveActionRequest.Status__c === "Customer Review" && 
          <FloatButton draftStatus={draftStatus} onSaveDraft={handleSaveCar} />
        }
        </>
      </Dialog>

      <Dialog header="Client Guidance Statement" className='clientstatementmodel' visible={clientstatementvisible} style={{ width: '50vw' }} onHide={() => { if (!clientstatementvisible) return; setClientStatementVisible(false); }}>
        <p className="m-0">
          Please review each finding thoroughly, noting the deadline assigned to each one. For each CAR, a representative must complete the client response section, including his/her name and the response date. Please be aware that additional evidence may be required by SCS before a finding can be closed, so allow sufficient time to ensure that all deadlines are met.
        </p>
        <br />
        <p className="m-0">
          <u>Response to Observations:</u> Observations are noted by the auditor where s/he identifies the early stages of a problem which does not in itself constitute a nonconformance, but which may lead to a future nonconformance if not addressed by the client. Such observations are recorded in the audit report for the benefit of the client. Therefore, although optional, SCS recommends that all clients respond to Observations.
        </p>
        <br />
        <p className="m-0">
          <u>Response to Minor CARs:</u> Minor CARs will be reviewed for closure 12 months from the date issued (above) or by the auditor at the next audit (for FSC, whichever is sooner; for PEFC, always at the audit), unless an earlier deadline is specified. For CARs to be reviewed at the next audit, please be prepared to present your evidence of corrective action and conformance to the auditor. Minor CARs not closed by the deadline will be upgraded to Major CARs. For PEFC, all Minor CARs must be closed prior to (re)certification.
        </p>
        <br />
        <p className="m-0">
          <u>Response to Major CARs:</u> All Major CARs must be closed prior to (re)certification, or within three (3) months of the date issued (above) for surveillance audits unless otherwise specified. Therefore, for each Major CAR please allow enough time to a) investigate the root cause(s) of the nonconformance, b) perform all necessary corrective actions to systematically resolve the nonconformance, and c) submit your evidence to SCS prior to the deadline and with enough time for review and request for more information, if necessary. Major CARs not closed by the deadline will cause a lapse in certification.
        </p>
        <br />
        <p className="m-0">
          Please email a completed copy of this form in Word format to SCS along with your CAR closure evidence at least two weeks before the deadline expires.
        </p>
      </Dialog>

      <SummaryReport
        isDrawerOpen={isSummaryReportVisible}
        setIsDrawerOpen={setSummaryReportVisible}
        selectedId={selectedId}
        report={selectedReport}
        selectedRowData={selectedRowData}


      />
      <Toaster
        type={tosterInfo.type}
        show={showToster}
        setShow={setShowToster}
        message={tosterInfo.message}
      />
    </div>
  );
};

export default DataTable;
